import Type from './Type';
import React from 'react';

function DocsForType({match, types}) {
  const type = types[match.params.name];
  return <Type {...type}/>
}

export default DocsForType;



// WEBPACK FOOTER //
// ./src/DocsForType.js